import { createFileRoute } from '@tanstack/react-router';

import { BatchDetailsPage } from '@contracts';

export const Route = createFileRoute(
  '/_app/os/contracts_/$contractId/batches_/$batchId',
)({
  component: BatchDetailsPage,
  pendingComponent: BatchDetailsPage.Skeleton,
});
